import { UserRole } from '@/core/domain/resources/enums/UserRole'
import { UserGender } from '@/core/domain/resources/enums/UserGender.ts'
import {
  type AvailableEducationalMemberEntity,
  AvailableEducationalMemberSchema
} from '@/core/infrastructure/schemas/school/user/AvailableEducationalMemberSchema.ts'
import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator.ts'

/**
 * Représente un membre éducatif disponible pour être ajouté à un établissement
 */
export class AvailableEducationalMember {
  identifier: string
  firstname: string
  lastname: string
  username: string
  email: string
  roles?: UserRole.SchoolValues[]
  gender: UserGender.Values
  birthdate?: string | null

  constructor(data: AvailableEducationalMemberEntity) {
    this.identifier = data.identifier
    this.firstname = data.firstname
    this.lastname = data.lastname
    this.username = data.username
    this.email = data.email
    this.roles = data.roles
    this.gender = data.gender
    this.birthdate = data.birthdate
  }

  /**
   * Crée une instance d'AvailableEducationalMember à partir des données brutes
   */
  static create(data: AvailableEducationalMemberEntity): AvailableEducationalMember {
    return EntityValidator.validateAndCreate(
      AvailableEducationalMemberSchema,
      data,
      AvailableEducationalMember,
      'AvailableEducationalMember'
    )
  }

  /**
   * Retourne le nom complet du membre
   */
  get fullName(): string {
    return `${this.firstname} ${this.lastname}`
  }

  /**
   * Retourne les initiales du membre
   */
  get initials(): string {
    const firstInitial = this.firstname.charAt(0).toUpperCase()
    const lastInitial = this.lastname.charAt(0).toUpperCase()
    return `${firstInitial}${lastInitial}`
  }

  /**
   * Vérifie si le membre correspond à une recherche
   */
  matchesSearch(query: string): boolean {
    const searchTerm = query.toLowerCase()
    return (
      this.fullName.toLowerCase().includes(searchTerm) ||
      this.username.toLowerCase().includes(searchTerm) ||
      this.email.toLowerCase().includes(searchTerm)
    )
  }
}
